import React from 'react';

const Img = (props: any) => {
  return <img draggable={false} alt='img' {...props} />;
};

export default Img;
